import { getWordEwssDisplayGrade } from "./ewssGradeDisplay";
import {
  getLastGameEntry,
  getWordGameCount,
  isGradeMastered,
} from "./registerWordListDisplay";

export const REGISTER_FILTERED_STAT_KEYS = {
  MASTERED: "mastered",
  REVIEW: "review",
  NEVER: "never",
  PLAYED_12: "played12",
};

export function categorizeRegisterFilteredWord(entry) {
  const gameCount = getWordGameCount(entry);
  const grade = getWordEwssDisplayGrade(entry);

  if (gameCount === 0) return REGISTER_FILTERED_STAT_KEYS.NEVER;
  if (grade && isGradeMastered(grade)) return REGISTER_FILTERED_STAT_KEYS.MASTERED;
  if (grade) return REGISTER_FILTERED_STAT_KEYS.REVIEW;
  if (gameCount <= 2) return REGISTER_FILTERED_STAT_KEYS.PLAYED_12;
  return REGISTER_FILTERED_STAT_KEYS.REVIEW;
}

function toPercent(count, total) {
  if (total <= 0) return 0;
  return Math.round((count / total) * 1000) / 10;
}

function buildMetric(count, total) {
  return {
    count,
    total,
    ratioLabel: `${count.toLocaleString("fr-FR")} / ${total.toLocaleString("fr-FR")}`,
    percentLabel: `${toPercent(count, total).toLocaleString("fr-FR", {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    })} %`,
  };
}

function getLastGameResult(entry) {
  const last = getLastGameEntry(entry?.stats) || getLastGameEntry(entry);
  if (!last?.result) return null;
  return last.result === "success" ? "success" : "fail";
}

export function computeRegisterFilteredStats(entries = []) {
  const counts = {
    [REGISTER_FILTERED_STAT_KEYS.MASTERED]: 0,
    [REGISTER_FILTERED_STAT_KEYS.REVIEW]: 0,
    [REGISTER_FILTERED_STAT_KEYS.NEVER]: 0,
    [REGISTER_FILTERED_STAT_KEYS.PLAYED_12]: 0,
  };

  let played12LastSuccess = 0;
  let played12LastFail = 0;
  let lastCorrectCount = 0;

  for (const entry of entries) {
    if (!entry?.mot) continue;
    const category = categorizeRegisterFilteredWord(entry);
    counts[category] += 1;

    const lastResult = getLastGameResult(entry);
    if (lastResult === "success") lastCorrectCount += 1;

    if (category === REGISTER_FILTERED_STAT_KEYS.PLAYED_12) {
      if (lastResult === "success") played12LastSuccess += 1;
      if (lastResult === "fail") played12LastFail += 1;
    }
  }

  const total = entries.filter((entry) => entry?.mot).length;
  const played12Total = counts[REGISTER_FILTERED_STAT_KEYS.PLAYED_12];

  return {
    total,
    mastered: buildMetric(counts.mastered, total),
    lastCorrect: buildMetric(lastCorrectCount, total),
    review: buildMetric(counts.review, total),
    never: buildMetric(counts.never, total),
    played12: {
      ...buildMetric(played12Total, total),
      lastSuccess: buildMetric(played12LastSuccess, played12Total),
      lastFail: buildMetric(played12LastFail, played12Total),
    },
  };
}
